import React, { Dispatch, SetStateAction } from 'react';
import {
  StyleSheet, Pressable, ScrollView, Text,
} from 'react-native';
import isMobile from '../../../IsMobile';
import { Template } from '../../../../constants/Types';
import { PressableState } from '../../../PressableStyled';
import Style from '../../../../constants/Style';
import Colors from '../../../../constants/Colors';

interface TemplateDropdownProps {
  templates: Template[],
  setSelectedTemplate: Dispatch<SetStateAction<Template>>,
}

const TemplateDropdown = ({
  templates, setSelectedTemplate,
}: TemplateDropdownProps) => <ScrollView
  nestedScrollEnabled
  indicatorStyle={'black'}
  style={[styles.container, isMobile ? { width: '100%' } : {}]}
>
    {templates?.sort((a: Template, b: Template) => a.name?.toLowerCase()
      .localeCompare(b.name?.toLowerCase()))
      .map((template: Template) => <Pressable
        onPress={() => setSelectedTemplate(template)}
        key={`add_asset_template_option_${template.id}`}
        style={({ hovered, pressed }: PressableState) => [
          hovered && Style.listItemHovered, pressed && Style.listItemPressed,
        ]}
      >
        <Text style={styles.dropdownItemText}>{template.name}</Text>
      </Pressable>)}
  </ScrollView>;

const styles = StyleSheet.create({
  container: {
    zIndex: 5,
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksPaleBlue900,
    backgroundColor: '#fff',
    marginTop: 4,
    maxHeight: 180,
    alignSelf: 'stretch',
  },
  dropdownItemText: {
    marginLeft: 12,
    marginVertical: 9,
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    color: Colors.light.hereworksPrimaryGrey,
  },
});

export default TemplateDropdown;
